import SurveyButton from '@/components/Base/SurveyButton';
import SurveyBackgroundLayout from '@/components/layout/SurveyBackgroundLayout';
import { SurveyContentPanel, SurveyContentPanelInset } from '@/components/layout/SurveyContentPanel';
import { useSurveyLanguage } from '@/hooks/useSurveyLanguage';
import { getTranslations } from '@/locales';
import { useNavigate } from 'react-router-dom';

export default function Home() {
  const navigate = useNavigate();
  const { setSurveyLanguage } = useSurveyLanguage();

  const goAgeSmoker = (lang: 'en' | 'bm') => {
    setSurveyLanguage(lang);
    navigate('/age_smoker');
  };

  const tEn = getTranslations('en').home;

  return (
    <SurveyBackgroundLayout>
      <div className="absolute z-10 inset-x-0 top-[10%] flex flex-col items-center text-center">
        <h1 className="text-[36px] font-semibold leading-tight tracking-tight text-white drop-shadow-[0_2px_8px_rgba(0,0,0,0.4)] sm:text-[42px]">
          <span className="block">Welcome</span>
          <span className="mt-1 block">Selamat Datang</span>
        </h1>
      </div>

      <div className="absolute z-10 inset-x-0 top-[26%] flex flex-col items-stretch gap-8">
        <SurveyContentPanelInset>
          <SurveyContentPanel className="flex min-h-[20.48rem] flex-col justify-center !py-[2.7rem] sm:min-h-[21.56rem]">
            <div className="mx-auto w-[95%]">
              <p className="m-0">
                {`${tEn.line1} ${tEn.line2} `}
                <span className="whitespace-nowrap">{tEn.line3}</span>
              </p>
              <p className="m-0 mt-[2.34lh]">{`${tEn.line4} ${tEn.line5} ${tEn.line6}`}</p>
            </div>
          </SurveyContentPanel>
        </SurveyContentPanelInset>

        <div className="flex flex-nowrap items-center justify-evenly px-6">
          <SurveyButton onClick={() => goAgeSmoker('en')}>ENG</SurveyButton>
          <SurveyButton onClick={() => goAgeSmoker('bm')}>BM</SurveyButton>
        </div>
      </div>
    </SurveyBackgroundLayout>
  );
}
